<template>
    <div class="w-full flex flex-col">
        <div v-if="loading" v-html="spinnerSrcCustomSize" class="h-8 flex items-center justify-center"></div>
        <template v-else>
            <div class="space-y-8 divide-y  sm:space-y-5">
                <div class="space-y-6 sm:space-y-5 bg-white">
                    <div v-if="adminMode" class="bold p-2 w-full">
                        {{ translate('If the content or the topics were not filled yet by the participant, saving changes will not be possible here, as the system expects these data.') }}
                    </div>

                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                         v-if="abstractfields['title']"
                    >
                        <label for="title" class="block text-sm text-gray-700 sm:mt-px sm:pt-2" v-html="translate(abstractfields.title.label)+'*'"></label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <input type="text" v-model="abstract.title" class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md">
                            <guideline :key="'gl-title'" guidelinekey="title" :guidelines="guidelines"></guideline>
                        </div>
                        <template v-if="errors['title']">
                            <div>&nbsp;</div>
                            <div class="pt-2 text-red-500 sm:col-span-2" v-html="errors['title']"></div>
                        </template>
                    </div>
                    <template v-if="!adminMode">
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                         v-if="abstractfields['primary_topic_id']"
                    >
                        <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2" v-html="translate(abstractfields.primary_topic_id.label)+'*'"></label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <select v-model="abstract.primary_topic_id"

                                    class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                                <option value="-1" v-html="translate('Please select one')"></option>
                                <option v-for="topic in abstractfields.primary_topic_id.valueset"
                                        :value="topic.id"
                                        v-html="translate(topic.name)"></option>
                            </select>
                            <guideline :key="'gl-primary-topic-id'" guidelinekey="primary-topic-id" :guidelines="guidelines"></guideline>

                        </div>
                        <template v-if="errors['primary_topic_id']">
                            <div>&nbsp;</div>
                            <div class="pt-2 text-red-500 sm:col-span-2" v-html="errors['primary_topic_id']"></div>
                        </template>
                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                         v-if="abstractfields['secondary_topic_id']"
                    >
                        <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2" v-html="translate(abstractfields.secondary_topic_id.label)+'*'"></label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <select v-model="abstract.secondary_topic_id"
                                    class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                                <option value="-1" v-html="translate('Please select one')"></option>
                                <option v-for="topic in abstractfields.secondary_topic_id.valueset"
                                        :value="topic.id"
                                        v-html="translate(topic.name)"></option>
                            </select>
                            <guideline :key="'gl-secondary-topic-id'" guidelinekey="secondary-topic-id" :guidelines="guidelines"></guideline>

                        </div>
                        <template v-if="errors['secondary_topic_id']">
                            <div>&nbsp;</div>
                            <div class="pt-2 text-red-500 sm:col-span-2" v-html="errors['secondary_topic_id']"></div>
                        </template>
                    </div>
                    </template>
                    <div class="w-full pt-2 mt-2 sm:border-t sm:border-gray-200" :class="{'opacity-50': moving}">
                        <div class="w-full pb-8 flex items-center justify-between">
                            <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2" v-html="translate('Author(s)')+'*'"></label>
                            <button class="bg-customindigo text-indigo-700"
                                    v-if="abstract.authors.length < conference.paper_max_number_of_authors"
                                    v-on:click="addAuthor"
                                    >
                                <i class="far fa-user"></i>
                                <span v-html="translate('Add author')"></span>
                            </button>
                        </div>
                        <template v-if="abstract.authors.length > 0">
                            <div v-for="author, index in abstract.authors" class="w-full flex items-start justify-start pb-4">
                                <span class="font-bold pr-2 lg:pr-6" v-html="(index + 1).toString()"></span>
                                <div v-if="abstract.authors.length > 1" class="hidden lg:flex items-start justify-end flex-row w-20">
                                    <button class="py-0 px-2 mx-1 bg-white border border-customindigo text-xl text-indigo-700 transition-colors hover:bg-customindigo" v-if="index > 0" v-on:click="moveAuthor(index, -1)">↑</button>
                                    <button class="py-0 px-2 mx-1 bg-white border border-customindigo text-xl text-indigo-700 transition-colors hover:bg-customindigo" v-if="index < abstract.authors.length - 1" v-on:click="moveAuthor(index, 1)">↓</button>
                                </div>
                                <div class="flex flex-col flex-grow hover:bg-gray-200 transition-colors">
                                    <div class="flex flex-col lg:flex-row flex-grow  items-center">
                                        <div class="w-full lg:w-auto flex flex-row flex-grow items-center justify-between lg:justify-start py-1 lg:py-2">
                                            <div v-if="abstract.authors.length > 1" class="flex items-start justify-start flex-row lg:hidden  w-10">
                                                <button class="py-0 px-2 mx-1 bg-white border border-customindigo text-xl text-indigo-700 transition-colors hover:bg-customindigo" v-if="index > 0" v-on:click="moveAuthor(index, -1)">↑</button>
                                                <button class="py-0 px-2 mx-1 bg-white border border-customindigo text-xl text-indigo-700 transition-colors hover:bg-customindigo" v-if="index < abstract.authors.length - 1" v-on:click="moveAuthor(index, 1)">↓</button>
                                            </div>
                                            <field-display-label :fields="authorFieldvalues(index, ['is_presenting_author'])"
                                                             class="ml-2 lg:ml-4 flex items-center flex-row bg-gray-100 lg:bg-transparent w-full lg:w-auto text-right lg:text-left flex-grow font-bold"
                                                             :class="{'underline': author.is_presenting_author == 1}"
                                                             :key="author.id"
                                                             v-if="author.id !== null"
                                                             :template-string="':firstname :lastname (presenting: :is_presenting_author)'"></field-display-label>

                                        </div>
                                        <div class="w-full lg:w-auto flex flex-row flex-grow items-center justify-start lg:justify-end pt-2 lg:pt-0">
                                            <button v-on:click="editAuthor(index)"
                                                    class="ml-auto p-2 bg-customindigo text-indigo-700"
                                                    v-html="translate('Edit author')"></button>
                                            <button v-on:click="addAffiliation(index)"
                                                    v-if="author.affiliations.length < conference.paper_max_number_of_affiliations"
                                                    class="ml-2 p-2 bg-customindigo text-indigo-700"
                                                    v-html="translate('Add affiliation')"></button>
                                            <button v-on:click="deleteAuthor(index)"
                                                    class="ml-2 p-2 bg-red-500 text-white"
                                            ><i class="far fa-trash mr-0"></i></button>
                                        </div>
                                    </div>
                                    <div class="flex flex-col pl-2 lg:pl-8">
                                        <div v-for="affiliation, affiliationIndex in author.affiliations" class="flex flex-row w-full justify-start items-center py-2">
                                            <div v-if="author.affiliations.length > 1" class="flex items-start justify-start lg:justify-end flex-col lg:flex-row  w-10 lg:w-20">
                                                <button class="py-0 px-2 mx-1 bg-white border border-customindigo text-xl text-indigo-700 transition-colors hover:bg-customindigo" v-if="affiliationIndex > 0" v-on:click="moveAffiliation(affiliationIndex, index, -1)">↑</button>
                                                <button class="py-0 px-2 mx-1 bg-white border border-customindigo text-xl text-indigo-700 transition-colors hover:bg-customindigo" v-if="affiliationIndex < author.affiliations.length - 1" v-on:click="moveAffiliation(affiliationIndex, index, 1)">↓</button>
                                            </div>

                                            <field-display-label                                                         :fields="affiliationFieldvalues(index, affiliationIndex)"
                                                    :key="affiliation.id"
                                                    :template-string="affiliationTemplateString">
                                            </field-display-label>
                                            <button class="bg-customindigo text-indigo-700 ml-auto p-2" v-on:click="editAffiliation(index, affiliationIndex)">
                                                <i class="far fa-pencil  mr-0"></i>
                                            </button>
                                            <button class="bg-red-500 text-white ml-2 p-2" v-on:click="deleteSelectedAffiliation(index, affiliationIndex)">
                                                <i class="far fa-trash  mr-0"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <template v-if="!adminMode">
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2">
                            <span v-html="translate('Abstract text')+'*'"></span>

                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <tiny-mce-wrapper v-model="abstract.content"
                                              :config="tinymceConfig"
                                              v-on:input="refreshLength"
                                              class="p-4 block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                                              style="min-height: 300px"></tiny-mce-wrapper>
                            <guideline :key="'gl-abstract-text'" guidelinekey="abstract-text" :guidelines="guidelines"></guideline>

                        </div>
                        <div>&nbsp;</div>
                        <div class="sm:col-span-2 flex items-start flex-col">
                            <div v-html="abstractContentLength+' / '+conference.paper_content_max_chars+' '+translate('characters')" class="mb-4"></div>
                            <div v-if="errors['content']" class="pt-2 text-red-500 sm:col-span-2" v-html="errors['content']"></div>
                        </div>

                    </div>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2">
                            <span v-html="translate('Acknowledgements')"></span>
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <textarea class="p-4 block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md" v-model="abstract.thank_and_support_text" style="min-height: 100px"></textarea>
                            <guideline :key="'gl-acknowledgements'" guidelinekey="acknowledgements" :guidelines="guidelines"></guideline>

                        </div>
                        <div>&nbsp;</div>
                        <div class="sm:col-span-2 flex items-start flex-col">
                            <div v-html="abstractThanksTextLength+' / '+conference.paper_thank_and_support_max_chars+' '+translate('characters')" class="mb-4"></div>
                            <div v-if="errors['thanks_and_support_text']" class="pt-2 text-red-500 sm:col-span-2" v-html="errors['thanks_and_support_text']"></div>
                        </div>

                        <template v-if="errors['thanks_and_support_text']">
                            <div>&nbsp;</div>
                            <div class="pt-2 text-red-500 sm:col-span-2" v-html="errors['thanks_and_support_text']"></div>
                        </template>
                    </div>
                    </template>
                    <div  v-if="adminMode" class="w-full pt-8">
                        <div class="flex w-full justify-center items-center pb-4">
                            <button type="button" class="bg-customindigo text-indigo-700 py-4" v-on:click="closeForm" v-html="translate('Save')"></button>
                            <button type="button" class="bg-gray-300 ml-8 py-4" :disabled="saving" v-on:click="closeWithoutSaving" v-html="translate('Cancel')"></button>
                        </div>
                    </div>
                    <div v-else class="w-full pt-8">
                        <div class="flex w-full justify-start items-center pb-8">
                            <div class="h-12 w-12 bg-customblue text-white text-4xl font-bold rounded-full flex items-center justify-center mr-4">!</div>
                            <div class="flex flex-col items-start">
                                <div v-html="translate('If you press <b>Save</b> and return to the list, you will be <b>able to edit</b> the abstract again.')"></div>
                                <div v-html="translate('If you press <b>Submit</b>, the abstract <b>will be submitted</b> and you will <b>not be able to edit</b> it any more.')"></div>
                            </div>

                        </div>
                        <div class="flex w-full justify-center items-center pb-4">
                            <button type="button" class="bg-customindigo text-indigo-700 py-4" v-on:click="closeForm" v-html="translate('Save and submit later')"></button>
                            <button type="button" class="bg-green-500 text-white ml-8 py-4" :disabled="saving" v-on:click="submitAbstract" v-html="translate('Preview and submit')"></button>
                            <button type="button" class="bg-gray-300 ml-8 py-4" :disabled="saving" v-on:click="closeWithoutSaving" v-html="translate('Cancel')"></button>
                        </div>
                        <div class="flex w-full justify-end items-center" v-html="status"></div>
                    </div>
                    <div class="w-full pt-2 flex items-center justify-center">
                        <span v-if="Object.keys(errors).length > 0" v-html="translate('There are invalid values selected, please correct them before saving or submitting')"></span>
                    </div>
                    <template v-if="adminMode">
                        <div v-if="errors['primary_topic_id']" class="pt-2 text-red-500 sm:col-span-2" v-html="errors['primary_topic_id']"></div>
                        <div v-if="errors['secondary_topic_id']" class="pt-2 text-red-500 sm:col-span-2" v-html="errors['secondary_topic_id']"></div>
                        <div v-if="errors['content']" class="pt-2 text-red-500 sm:col-span-2" v-html="errors['content']"></div>
                        <div v-if="errors['thanks_and_support_text']" class="pt-2 text-red-500 sm:col-span-2" v-html="errors['thanks_and_support_text']"></div>

                    </template>
                </div>
            </div>

        </template>
        <popup :visible="showAuthorPopup">
            <div class="space-y-8 sm:space-y-5" v-if="selectedAuthor != null && showAuthorPopup">
                <h3 v-html="authorPopupTitle"></h3>
                <div class="space-y-6 sm:space-y-5 bg-white">
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                         v-for="field, index in authorfields"
                    >
                        <template v-if="field.valueset === null">
                            <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2" v-html="field.label+mandatoryAsterisk(field)"></label>
                            <div class="mt-1 sm:mt-0 sm:col-span-2">
                                <input type="text" v-model="abstract.authors[selectedAuthorIndex][field.field]" class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md">
                                <guideline :key="'gl-author-'+field.field" :guidelinekey="'author.'+field.field" :guidelines="guidelines"></guideline>

                            </div>
                            <div v-if="subItemErrors.author[field.field]" class="pt-2 text-red-500 sm:col-span-2" v-html="subItemErrors.author[field.field]"></div>
                        </template>
                        <template v-if="field.valueset !== null">
                            <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2" v-html="field.label+mandatoryAsterisk(field)"></label>
                            <div class="mt-1 sm:mt-0 sm:col-span-2">
                                <select v-model="abstract.authors[selectedAuthorIndex][field.field]" class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md">
                                    <option v-for="valuesetItem in field.valueset"
                                            :value="valuesetItem.value"
                                            v-html="valuesetItem.label"></option>
                                </select>
                                <guideline :key="'gl-author-'+field.field" :guidelinekey="'author.'+field.field" :guidelines="guidelines"></guideline>
                            </div>
                            <div v-if="subItemErrors.author[field.field]" class="pt-2 text-red-500 sm:col-span-2" v-html="subItemErrors.author[field.field]"></div>
                        </template>
                    </div>
                </div>
                <template v-if="selectedAuthor.id === null">
                    <affiliation-form :value="selectedAffiliation"
                                      :affiliation-template-string="affiliationTemplateString"
                                      :participant-affiliations="participantAffiliations"
                                      :affiliationfields="affiliationfields"
                                      :author="selectedAuthor"
                                      :affiliation-index="selectedAffiliationIndex"
                                      :errors="subItemErrors.affiliation"
                                      :guidelines="guidelines"
                                      v-on:saveaffiliation="saveAffiliation"
                                      v-on:saveexistingaffiliation="saveExistingAffiliation($event)"
                                      v-on:deleteaffiliation="deleteAffiliation"
                                      v-on:cancelaffiliationEditing="cancelAffiliationEditing"
                                      v-on:clonecurrentaffiliation="cloneCurrentAffiliation"
                                      :resetflag="affiliationFormKey"
                                      v-on:affiliationmode="affiliationMode = $event"
                                      v-on:assignedaffiliation="assignExistingAffiliation = $event"
                                      :show-buttons="false"
                    ></affiliation-form>

                </template>
                <div class="pt-8 w-full flex items-center justify-between">
                    <button v-on:click="saveAuthor" class="bg-customindigo text-indigo-700" v-html="translate('Save')"></button>
                    <button v-on:click="cancelAuthorEditing" class="bg-gray-300" v-html="translate('Close')"></button>
                </div>
            </div>
        </popup>
        <popup :visible="showAffiliationPopup">
            <template v-if="showAffiliationPopup">
                <affiliation-form :value="selectedAffiliation"
                                  :affiliation-template-string="affiliationTemplateString"
                                  :participant-affiliations="participantAffiliations"
                                  :affiliationfields="affiliationfields"
                                  :author="selectedAuthor"
                                  :affiliation-index="selectedAffiliationIndex"
                                  :errors="subItemErrors.affiliation"
                                  :guidelines="guidelines"
                                  v-on:saveaffiliation="saveAffiliation"
                                  v-on:saveexistingaffiliation="saveExistingAffiliation($event)"
                                  v-on:deleteaffiliation="deleteAffiliation"
                                  v-on:cancelaffiliationEditing="cancelAffiliationEditing"
                                  v-on:clonecurrentaffiliation="cloneCurrentAffiliation"
                                  v-on:affiliationmode="affiliationMode = $event"
                                  v-on:assignedaffiliation="assignExistingAffiliation = $event"
                                  :resetflag="affiliationFormKey"
                ></affiliation-form>
            </template>
        </popup>
        <div style="padding: 0px; margin: 0px; display: none; width: 0px; height: 0px;"
             :ref="'abstractcontent'"
             ></div>
    </div>
</template>

<script>
    import FieldDisplayLabel from "./FieldDisplayLabel";
    import Guideline from "./Guideline";
    export default {
        components: {FieldDisplayLabel, Guideline},
        props: {
            conference: {type: Object},
            operationsUrl: {type: String},
            affiliationfields: {type: Array},
            authorfields: {type: Array},
            topics: {type: Array},
            affiliationTemplateString: {type: String, default: ':institution :department :laboratory :place :country_id">'},
            guidelines: {type: Object},
            adminMode: {type: Boolean, default: false},
            participantId: {type: Number, default: -1}
        },
        inject: ['translate'],
        data: function () {
            return {
                affiliationFormKey: 0,
                saving: false,
                spinnerSrcCustomSize: '<img style="height: 100%" alt="" src="data:image/svg+xml;base64,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" />',
                loading: true,
                abstract: {},
                abstractfields: {},
                participantAffiliations: [],
                errors: {},
                status: '',
                saveTimeout: null,
                scramble: '',
                initialized: false,
                selectedAuthorIndex: null,
                selectedAffiliationIndex: null,
                subItemErrors: {author: {}, affiliation: {}},
                moving: false,
                showAuthorPopup: false,
                showAffiliationPopup: false,
                affiliationMode: -1,
                assignExistingAffiliation: -1,
                tinymceConfig: {
                    plugins: [
                        'charmap'
                    ],
                    toolbar: [
                        'bold italic subscript superscript',
                    ],
                    menubar: '',
                    content_css: '/css/app.css',
                    content_style: 'p {line-height: 1.5 !important}'
                        + '@font-face {font-family: \'Symbol\';src: url(\'/webfonts/symbol-webfont3.woff\') format(\'woff\');font-weight: normal;font-style: normal;}'
                        + '.mce-content-body {padding: .5rem}'
                },
                abstractContentLength: 0,
            }
        },
        created() {
        },
        mounted() {
            window.setInterval(() => {
                window.axios.post(this.operationsUrl, {operation: 'keepalive'}).then((response) => {});
            }, 10 * 60 * 1000);
            window.axios.post(this.operationsUrl, {operation: 'fetch', id: this.id, participant_id: this.participantId})
                .then((response) => {
                    this.participantAffiliations = response.data.participantAffiliations;
                    this.abstract = response.data.abstract;
                    this.abstractfields = response.data.abstractfields;
                    if (this.abstract.primary_topic_id == null) {
                        this.abstract.primary_topic_id = -1;
                    }
                    if (this.abstract.secondary_topic_id == null) {
                        this.abstract.secondary_topic_id = -1;
                    }
                    this.loading = false;
                    this.initialized = true;
                })
        },
        methods: {
            closeWithoutSaving: function() {
                let confirmed = Object.keys(this.errors).length == 0
                    ? true
                    : window.confirm(this.translate('Some fields were not saved due to invalid values. Changes to these fields will be lost. Are you sure you want to return to the list?'));
                if (confirmed) {
                    if (this.adminMode) {
                        this.$emit('cancel');
                        return;
                    }
                    window.location.href = '/';
                }
            },
            editAffiliation: function(authorIndex, index) {
                this.selectedAuthorIndex = authorIndex;
                this.selectedAffiliationIndex = index;
                this.affiliationFormKey = Math.random();
                this.showAffiliationPopup = true;
            },
            cloneCurrentAffiliation: function() {
                window.axios.post(this.operationsUrl, {
                    operation: 'cloneaffiliation',
                    author_id: this.selectedAuthor.id,
                    data: this.selectedAffiliation,
                    participant_id: this.participantId
                }).then((response) => {
                        this.abstract.authors = [];
                        response.data.authors.forEach((i) => {
                            this.abstract.authors.push(i);
                        })
                        this.participantAffiliations = [];
                        response.data.participantAffiliations.forEach((i) => {
                            this.participantAffiliations.push(i);
                        });
                        this.showAffiliationPopup = false;
                        this.selectedAffiliationIndex = null;
                    }).catch((error) => {
                    this.moving = false;
                })
            },
            saveExistingAffiliation: function(assignExistingAffiliation, callback = null) {
                window.axios.post(this.operationsUrl, {operation: 'assignaffiliation', author_id: this.selectedAuthor.id, id: assignExistingAffiliation, participant_id: this.participantId })
                    .then((response) => {
                        this.abstract.authors = [];
                        response.data.authors.forEach((i) => {
                            this.abstract.authors.push(i);
                        });
                        this.showAffiliationPopup = false;
                        this.selectedAffiliationIndex = null;
                        this.moving = false;
                        if (callback) {
                            callback(response);
                        }
                    }).catch((error) => {
                    this.moving = false;
                })

            },
            showAffiliationForm: function(index, affiliationIndex) {
                this.selectedAffiliationIndex = affiliationIndex;
                this.selectedAuthorIndex = index;
                this.affiliationMode = -1;
                this.showAffiliationPopup = true;
            },
            cancelAffiliationForm: function() {
                this.showAffiliationPopup = false;
            },
            authorFieldvalues: function(index, except = []) {
                let result = [];
                this.authorDisplayFields.forEach((f) => {
                    if (!except.includes(f.field)) {
                        let i = {...f};
                        i.value = this.abstract.authors[index][f.field];
                        result.push(i);
                    }
                });
                return result;
            },
            affiliationFieldvalues: function(authorIndex, index) {
                let result = [];
                this.affiliationfields.forEach((f) => {
                    let i = {...f};
                    i.value = this.abstract.authors[authorIndex].affiliations[index][f.field];
                    result.push(i);
                });
                return result;
            },
            cancelAuthorEditing: function() {
                if (this.abstract.authors[this.selectedAuthorIndex].id === null) {
                    this.abstract.authors.splice(this.selectedAuthorIndex, 1);
                }
                this.selectedAuthorIndex = null;
                this.showAuthorPopup = false;
            },
            cancelAffiliationEditing: function() {
                if (this.selectedAuthor.affiliations[this.selectedAffiliationIndex].id === null) {
                    this.selectedAuthor.affiliations.splice(this.selectedAffiliationIndex, 1);
                }
                this.selectedAffiliationIndex = null;
                this.showAffiliationPopup = false;
            },
            moveAffiliation: function(index, authorIndex, direction) {
                this.moving = true;
                window.axios.post(this.operationsUrl, {operation: 'moveaffiliation', author_id: this.abstract.authors[authorIndex].id, id: this.abstract.authors[authorIndex].affiliations[index].id, direction: direction, participant_id: this.participantId })
                    .then((response) => {
                        this.abstract.authors = [];
                        response.data.authors.forEach((i) => {
                            this.abstract.authors.push(i);
                        })
                        this.selectedAffiliationIndex = null;
                        this.moving = false;
                    }).catch((error) => {
                        this.moving = false;
                    })

            },
            moveAuthor: function(index, direction) {
                this.moving = true;
                window.axios.post(this.operationsUrl, {operation: 'moveauthor', id: this.abstract.authors[index].id, direction: direction, participant_id: this.participantId })
                    .then((response) => {
                        this.abstract.authors = [];
                        response.data.authors.forEach((i) => {
                            this.abstract.authors.push(i);
                        })
                        this.selectedAuthorIndex = null;
                        this.moving = false;
                    }).catch((error) => {
                        this.moving = false;
                    })
            },
            deleteSubItem: function(payload) {
                if (window.confirm(this.translate('Are you sure you want to delete this')+' '+payload.subject+'? The process cannot be reverted.')) {
                    let data = {};
                    Object.keys(payload.data).forEach((field) => {
                        data[field] = payload.data[field];
                    });
                    data['id'] = payload.id;
                    window.axios.post(this.operationsUrl, {operation: 'delete'+payload.subject, subject: payload.subject, subjectData: data, participant_id: this.participantId })
                        .then((response) => {
                            this.abstract.authors = [];
                            response.data.authors.forEach((i) => {
                                this.abstract.authors.push(i);
                            });
                            this.participantAffiliations = [];
                            response.data.participantAffiliations.forEach((i) => {
                                this.participantAffiliations.push(i);
                            });
                            if (payload.subject == 'author') {
                                this.selectedAuthorIndex = null;
                                this.showAuthorPopup = false;
                            }
                            if (payload.subject == 'affiliation') {
                                this.selectedAffiliationIndex = null;
                                this.showAffiliationPopup = false;
                            }
                        }).catch((error) => {
                        if (error.response.status == 422) {
                            Object.keys(error.response.data.errors).forEach((errorKey) => {
                                Vue.set(this.subItemErrors[payload.subject], errorKey, error.response.data.errors[errorKey][0]);
                            });
                        } else {

                        }
                    })

                }
            },
            submitAbstract: function() {
                this.saveData(() => {
                    if (window.confirm(this.translate('After submitting the abstract you will not be able to edit it any more. Are you sure?'))) {
                        this.status = this.translate('Submitting abstract...');
                        window.axios.post(this.operationsUrl, {operation: 'submitAbstractPreview', id: this.abstract.id, participant_id: this.participantId})
                            .then((response) => {
                                window.location.href = response.data;
                            }).catch((error) => {
                                if (error.response.status == 422) {
                                    window.alert(error.response.data);
                                } else {
                                    alert('Submission failed, please try again later.')
                                }
                                this.status = '';
                            })
                    }
                });
            },
            saveAuthor: function() {
                this.subItemErrors.affiliation = {};
                if ((this.selectedAuthor.id === null) && (this.affiliationMode == -1)) {
                    this.subItemErrors.affiliation = {'affiliationMode': this.translate('Please add an affiliation to continue')}
                    return;
                }
                if ((this.selectedAuthor.id === null) && (this.affiliationMode == 'select') && (this.assignExistingAffiliation == -1)) {
                    this.subItemErrors.affiliation = {'affiliationMode': this.translate('Please select an affiliation to use')}
                    return;
                }
                let payload = {
                    subject: 'author',
                    data: {},
                    id: this.selectedAuthor.id,
                };
                this.authorfields.forEach((f) => {
                    payload.data[f.field] = this.selectedAuthor[f.field];
                });
                if (payload.id === null) {
                    this.validateSubItem(payload, () => {
                        if (this.affiliationMode == 'select') {
                            this.saveSubItem(payload, () => {
                                this.selectedAuthorIndex = this.abstract.authors.length - 1;
                                this.saveExistingAffiliation(this.assignExistingAffiliation);
                                this.showAuthorPopup = false;
                            }, false);
                        } else {
                            this.saveAffiliation((response) => {
                                payload.data['affiliation_id'] = response.data.affiliation.id;
                                this.saveSubItem(payload, () => {

                                    this.showAuthorPopup = false;
                                    this.selectedAuthorIndex = null;
                                }, false);
                            }, false)
                        }
                    }, false)
                } else {
                    this.saveSubItem(payload);
                }
            },
            saveAffiliation: function(callback = null, closePopup = true) {
                let payload = {
                    subject: 'affiliation',
                    data: {},
                    id: this.selectedAffiliation.id
                };
                this.affiliationfields.forEach((f) => {
                    payload.data[f.field] = this.selectedAffiliation[f.field];
                });
                payload.data['author_id'] = this.selectedAuthor.id;
                this.saveSubItem(payload, callback, closePopup);
            },
            deleteAuthor: function(index) {
                this.selectedAuthorIndex = index;
                let payload = {
                    subject: 'author',
                    data: {},
                    id: this.abstract.authors[this.selectedAuthorIndex].id,
                };
                this.authorfields.forEach((f) => {
                    payload.data[f.field] = this.abstract.authors[this.selectedAuthorIndex][f.field];
                });
                this.deleteSubItem(payload);
            },
            deleteSelectedAffiliation(authorIndex, affiliationIndex) {
                this.selectedAuthorIndex = authorIndex;
                this.selectedAffiliationIndex = affiliationIndex;
                this.deleteAffiliation();
            },
            deleteAffiliation: function() {
                let payload = {
                    subject: 'affiliation',
                    data: {},
                    id: this.selectedAffiliation.id,
                };
                this.affiliationfields.forEach((f) => {
                    payload.data[f.field] = this.selectedAffiliation[f.field];
                });
                payload.data['author_id'] = this.selectedAuthor.id;
                this.deleteSubItem(payload);
            },
            saveSubItem: function(payload, callback = null, closePopup = true) {
                //console.log({p: payload, c: callback, cp: closePopup});
                let data = {};
                Object.keys(payload.data).forEach((field) => {
                    data[field] = payload.data[field];
                });
                data['id'] = payload.id;
                this.subItemErrors[payload.subject] = {};
                window.axios.post(this.operationsUrl, {operation: 'save'+payload.subject, subject: payload.subject, subjectData: data, participant_id: this.participantId })
                    .then((response) => {
                        if (payload.subject == 'author') {
                            //this.selectedAuthorIndex = null;
                            if (closePopup) {
                                this.showAuthorPopup = false;
                            }
                        }
                        if (payload.subject == 'affiliation') {
                            //this.selectedAffiliationIndex = null;
                            if (closePopup) {
                                this.showAffiliationPopup = false;
                            }
                        }
                        this.abstract.authors = [];
                        response.data.authors.forEach((i) => {
                            this.abstract.authors.push(i);
                        })
                        if(response.data.participantAffiliations) {
                            this.participantAffiliations = response.data.participantAffiliations;
                        }
                        if (callback) {
                            callback(response);
                        }

                    }).catch((error) => {
                        console.log(error);
                        if (error.response.status == 422) {
                            Object.keys(error.response.data.errors).forEach((errorKey) => {
                                Vue.set(this.subItemErrors[payload.subject], errorKey, error.response.data.errors[errorKey][0]);
                            });

                        }
                    })
            },
            validateSubItem: function(payload, callback = null) {
                let data = {};
                Object.keys(payload.data).forEach((field) => {
                    data[field] = payload.data[field];
                });
                data['id'] = payload.id;
                data['validate-only'] = 1;
                this.subItemErrors[payload.subject] = {};
                window.axios.post(this.operationsUrl, {operation: 'save'+payload.subject, subject: payload.subject, subjectData: data, participant_id: this.participantId })
                    .then((response) => {
                        if (callback) {
                            callback(response);
                        }

                    }).catch((error) => {
                        if (error.response.status == 422) {
                            Object.keys(error.response.data.errors).forEach((errorKey) => {
                                Vue.set(this.subItemErrors[payload.subject], errorKey, error.response.data.errors[errorKey][0]);
                            });

                        }
                    })
            },
            saveData: function(callback) {
                this.saving = true;
                window.axios.post(this.operationsUrl, {operation: 'save', abstract: this.abstract, participant_id: this.participantId})
                    .then((response) => {
                        this.errors = {};
                        this.status = this.translate('All changes saved');
                        this.saving = false;
                        if (callback) {
                            callback(response);
                        }
                    }).catch((error) => {
                        if (error.response.status == 422) {
                            this.errors = {};
                            this.status = '';
                            Object.keys(error.response.data.errors).forEach((errorKey) => {
                                Vue.set(this.errors, errorKey, error.response.data.errors[errorKey][0]);
                            });
                        } else {
                            alert('There was an error, please try again later or contact the administrators');
                        }
                        this.saving = false;
                })
            },
            closeForm: function() {
                this.saveData((response) => {
                    window.location.href = '/';
                })
            },
            addAuthor: function() {
                let newAuthor = {id: null};
                this.authorfields.forEach((f) => {
                    newAuthor[f.field] = f.value;
                });
                newAuthor['affiliations'] = [];

                this.abstract.authors.push(newAuthor);
                this.selectedAuthorIndex = this.abstract.authors.length - 1;
                this.affiliationFormKey = Math.random();
                this.pushNewAffiliation();
                this.editAuthor(this.selectedAuthorIndex)
            },
            editAuthor: function(index) {
                this.selectedAuthorIndex = index;
                this.showAuthorPopup = true;
            },
            pushNewAffiliation: function() {
                let newAffiliation = {id: null};
                this.affiliationfields.forEach((f) => {
                    newAffiliation[f.field] = f.value;
                });
                newAffiliation.authoraffiliations_count = 0;
                this.selectedAuthor.affiliations.push(newAffiliation);
                this.selectedAffiliationIndex = this.selectedAuthor.affiliations.length - 1;
            },
            addAffiliation: function(index) {
                this.affiliationFormKey = Math.random();
                this.selectedAuthorIndex = index;
                this.pushNewAffiliation();
                this.affiliationMode = -1;
                this.assignExistingAffiliation = -1;
                this.showAffiliationPopup = true;
            },
            showAddAuthorButton: function(index) {
                if ((!this.abstract['authors']) || (!this.abstract.authors[index]))  {
                    return false;
                }
                if (this.abstract.authors.length == 0) {
                    return true;
                }
                if (this.abstract.authors[index].id == null) {
                    return false;
                }
                return index == this.abstract.authors.length - 1;
            },
            mandatoryAsterisk: function(field) {
                return field.mandatory === true ? '*' : '';
            },
            refreshLength: function(payload) {
                this.$refs['abstractcontent'].innerHTML = payload;
                this.abstractContentLength = this.$refs['abstractcontent'].innerText.length.toString();
            }
        },
        computed: {
            authorDisplayFields: function() {
                let result = [];
                result.push(this.authorfields.find(i => i.field == 'lastname'));
                result.push(this.authorfields.find(i => i.field == 'firstname'));
                return result;
            },
            presentingAuthorSet: function() {
                return this.abstract.authors.filter((a) => {
                    return a.is_presenting_author == 1;
                }).length > 0;
            },
            abstractThanksTextLength: function() {
                if (!this.abstract.thank_and_support_text) {
                    return 0;
                }
                return this.abstract.thank_and_support_text.length.toString();
            },
            abstractChecksum: function() {
                return this.abstract.title
                    +this.abstract.primary_topic_id
                    +this.abstract.secondary_topic_id
                    +this.abstract.content
                    +this.abstract.thank_and_support_text
                    +this.abstract.is_participant_plenary_speaker
                    +this.scramble;
            },
            selectedAuthor: function() {
                if (this.selectedAuthorIndex === null) {
                    return null;
                }
                if (this.abstract.authors[this.selectedAuthorIndex]) {
                    return this.abstract.authors[this.selectedAuthorIndex];
                }

                return null;
            },
            selectedAffiliation: function() {
                if (!this.selectedAuthor) {
                    return null;
                }
                if (this.selectedAuthor.affiliations[this.selectedAffiliationIndex]) {
                    return this.abstract.authors[this.selectedAuthorIndex].affiliations[this.selectedAffiliationIndex];
                }

                return null;
            },
            affiliationFormTitle: function() {
                if (!this.selectedAffiliation) {
                    return '';
                }
                return this.selectedAffiliation.id === null
                    ? this.translate('Add affiliation')
                    : this.translate('Edit affiliation');
            },
            authorPopupTitle: function() {
                if (!this.selectedAuthor) {
                    return '';
                }
                return this.selectedAuthor.id === null
                    ? this.translate('Add author')
                    : this.translate('Edit author');
            }
        },
        watch: {
            abstractChecksum: function() {
                if (this.initialized === true) {
                    window.clearTimeout(this.saveTimeout);
                    this.status = this.translate('Saving...');
                    this.saveTimeout = window.setTimeout(() => {
                        this.saveData();
                    }, 3000);
                }
            },
            affiliationMode: function() {
                if (this.subItemErrors.affiliation['affiliationMode']) {
                    this.subItemErrors.affiliation = {};
                }
            },
            assignExistingAffiliation: function() {
                if (this.subItemErrors.affiliation['affiliationMode']) {
                    this.subItemErrors.affiliation = {};
                }
            }
        }

    }
</script>
